import React, { lazy, Suspense } from 'react';
import { useLocation } from '@reach/router';
import Header from 'components/Header';
import Footer from 'components/Footer';
import CookiesPolicy from 'components/CookiesPolicy';

const SuccessModal = lazy(() => import('components/Modals/SuccessModal'));
const ErrorModal = lazy(() => import('components/Modals/ErrorModal'));
const ConsentModal = lazy(() => import('components/Modals/ConsentModal'));
const LangNotificationModal = lazy(() => import('components/Modals/LangNotificationModal'));
const WhitePaperSuccessModal = lazy(() =>
  import('components/Modals/WhitePaperSuccessModal/WhitePaperSuccessModal'),
);

function PageLayout({ children, pageContext }) {
  const location = useLocation();
  const showLayout = location.pathname.startsWith('/pdf/') === false;
  const is404 =
    pageContext.pagePath === '/404' ||
    pageContext.pagePath === '/404.html' ||
    pageContext.pagePath === '/dev-404-page';

  return (
    <>
      {showLayout && <Header is404={is404} />}
      <main>{children}</main>
      {showLayout && <Footer />}
      <Suspense fallback={null}>
        <SuccessModal />
        <ErrorModal />
        <ConsentModal />
        <LangNotificationModal />
        <WhitePaperSuccessModal />
      </Suspense>
      <CookiesPolicy />
    </>
  );
}

export default PageLayout;
